import { captureException } from '@sentry/nextjs';
import { transformGoogleSizeGuideData } from '@app/lib/google/size-guide';

/* IMPORTANT: Since we're using googleapis and not Next's fetch function, 
we don't get the nice automatic caching and revalidation options.
We need to think about what to do instead. */

async function fetchAndTransformGoogleSizeGuideData() {
    return fetch('/api/size-guide', {
        next: {
            tags: ['size-guide', 'product'],
            revalidate: 3600,
        },
    })
        .then((response) => response.json())
        .then((response) => {
            const transformedData = transformGoogleSizeGuideData(
                response.data.values
            );
            return transformedData;
        })
        .catch((error) => {
            captureException(error);
            return null;
        });
}

export default fetchAndTransformGoogleSizeGuideData;
